// src/api/http.js
import axios from 'axios';

/**
 * Prod: kör på samma origin (https://app.kmaavfall.se)
 * Dev: om du kör CRA på :3000, skjut mot backend :5000
 */
function resolveBaseURL() {
  const { protocol, hostname, port } = window.location;

  // Prod-domänen
  if (hostname === 'app.kmaavfall.se') return `${protocol}//${hostname}`;

  // CRA dev-server (port 3000)
  if (port === '3000') return 'http://localhost:5000';

  // Fallback: samma origin (t.ex. om du öppnar build lokalt bakom nginx)
  return `${protocol}//${hostname}${port ? ':' + port : ''}`;
}

const api = axios.create({
  baseURL: resolveBaseURL(),
  withCredentials: true, // <- Viktigt för avf.sid-cookien
  headers: { 'Content-Type': 'application/json' },
});

// (valfritt) enkel fel-logg vid 401/500 under utveckling
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[api error]', err?.response?.status, err?.response?.data || err.message);
    }
    return Promise.reject(err);
  }
);

export default api;
